import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDispatch } from 'src/store/useDispatch';
import { useAdminPermissions } from 'src/hooks/useAdminPermissions';
import { fetchAdminProfile } from 'src/store/slice/adminSession';
import { getFirstAccessibleRoute } from 'src/utils/permissions';
import { SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP } from 'src/utils/constants';
import { ROUTE_LOGIN } from 'src/utils/routes';
import { useTheme } from 'src/useTheme';
import { ContentSkeleton } from 'src/components/ContentSkeleton';
import { Container } from 'src/components/Container';

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { permissions, initialized } = useAdminPermissions();

  useEffect(() => {
    const access = localStorage.getItem('access');

    if (!access) {
      navigate(ROUTE_LOGIN, { replace: true });
      return;
    }

    if (!initialized) {
      dispatch(fetchAdminProfile());
      return;
    }

    const route = getFirstAccessibleRoute(permissions, SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP);
    navigate(route ?? ROUTE_LOGIN, { replace: true });
  }, [dispatch, navigate, permissions, initialized]);

  return (
    <Container height="100vh" minHeight="100dvh" padding="2rem" background={theme.lightGrey}>
      <ContentSkeleton variant="minimal" />
    </Container>
  );
};

export default HomePage;
